function stickyBlock() {
  var stickyBlock = $("<div id='sticky-block'></div>");
  var mobileHeaderHeight = $('.mobile-header').outerHeight()

  stickyBlock.insertBefore('#view-box-site');
  stickyBlock.css({'height': mobileHeaderHeight, 'width': '100%'});
}


if ($('.mobile-header').is(':visible')) {
  stickyBlock();
};
